import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { ContainerGradeRepairCodeSearchTextForm } from '../../../form-model/container-grade-repair-code-search-text.form.model';

@Component({
  selector: 'app-container-grade-repair-code-search',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './container-grade-repair-code-search.component.html',
  styleUrl: './container-grade-repair-code-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContainerGradeRepairCodeSearchComponent implements OnInit {
  @Input({ required: true }) searchTextForm!: FormGroup<ContainerGradeRepairCodeSearchTextForm>;

  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.addControlsToTheFormGroup();
  }

  applySearchTextFilters(): void {
    this.searchTextForm.controls.appliedSearchTextFilter.setValue(true);
  }

  isControlInErrorState(control: FormControl): boolean | null {
    if (control.invalid && control.touched) {
      return true;
    }
    return null;
  }

  private addControlsToTheFormGroup(): void {
    if (!this.searchTextForm.get('SearchText')) {
      this.searchTextForm.addControl('SearchText', this.formBuilder.control<string | null>(null));
    }
    if (!this.searchTextForm.get('appliedSearchTextFilter')) {
      this.searchTextForm.addControl('appliedSearchTextFilter', this.formBuilder.control<boolean | null>(null));
    }
  }
}
